<template>
  <section class="transactions">
    <template v-if="items.length > 0">
      <b-media class="mb-3" no-body v-for="item in items" :key="item.id">
        <template>
          <b-media-body class="ml-3 overflow-hidden" style="box-shadow: 0 5px 20px 0 rgb(218 222 229 / 58%); border-radius: 5px; overflow: hidden; white-space: nowrap">
            <b-list-group>
              <b-list-group-item style="padding-block: 3px; border-color: transparent">
                <i class="far fa-coins"/> <span class="text-secondary"><b>{{ item.value }}</b></span> <b>{{ item.contract ? item.symbol : 'EVC' }}</b> <b-badge class="text-muted" variant="light"><small class="text-muted" style="font-size: 12px">{{ $t('explorer.ln_41') }}: <span>{{ item.fee.slice(0,8) }}</span> EVC</small></b-badge><b-badge v-if="item.deploy" variant="primary">DC</b-badge>
              </b-list-group-item>
              <b-list-group-item style="padding-block: 3px; border-color: transparent; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                <template v-if="item.check_nonce && item.status > 0">
                  <i class="fas fa-check-circle mr-2"/>
                </template>
                <template v-else>
                  <i class="fas fa-do-not-enter mr-2"/>
                </template>
                <router-link v-b-tooltip.hover :title="item.hash" class="text-space" :to="{ path: '/explorer/tx/'+ item.hash}">
                  <b><i class="fas fa-hashtag"/> {{ item.hash}}</b></router-link>
              </b-list-group-item>
              <b-list-group-item style="padding-block: 3px; border-color: transparent">
                <i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/>
              </b-list-group-item>
              <b-list-group-item style="padding-block: 3px; border-color: transparent">
                <b-row class="text-center">
                  <b-col lg="3" >
                    <widget class="mt-4" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"  :scope-address="item.from" scope-template="transfer-user"/>
                  </b-col>
                  <b-col lg="1">
                    <i class="far fa-arrow-circle-right text-danger fs-25 my-5"/>
                  </b-col>
                  <b-col lg="4">
                    <template v-if="item.contract">
                      <widget class="mt-4" :scope-address="item.contract" scope-template="transfer-user"/>
                    </template>
                    <template v-else>
                      <i class="fas fa-file-signature my-5" style="font-size:30px;"></i>
                    </template>
                  </b-col>
                  <b-col lg="1">
                    <i class="far fa-arrow-circle-right text-success fs-25 my-5"/>
                  </b-col>
                  <b-col lg="3" >
                    <widget class="mt-4" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"  :scope-address="item.to" scope-template="transfer-user"/>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-media-body>
        </template>
      </b-media>
      <b-button v-if="more.show" @click="getMore" class="mb-3 w-100" variant="light">
        <b-spinner v-if="more.loading" small/>
        <i v-else class="fas fa-angle-down text-info"></i>
      </b-button>
    </template>
    <template v-else>
      <template v-if="delay">
        <div class="my-5 py-5">
          <b-skeleton style="margin: 0 auto 10px;" type="avatar"/>
          <b-skeleton style="margin: 0 auto 10px;" width="50%"/>
          <b-skeleton style="margin: 0 auto;" width="80%"/>
        </div>
      </template>
      <template v-else>
        <div class="text-center my-5 py-5">
          <i class="mb-4 display-4 fal fa-coins"/>
          <h3>{{ $t('wallet.ln_6') }}</h3>
        </div>
      </template>
    </template>
  </section>
</template>

<script lang="js">

import api from "../../libs/api";
import axios from 'axios';
import TimeAgo from 'vue2-timeago';
import Widget from '../../components/Widget';

export default {
  name: "wallet.transactions",
  data() {
    return {
      item: {
        id: null,
        hash: null,
        value: null,
        contract: null,
        from: null,
        to: null,
        fee: 0,
        deploy: false,
        check_nonce: true,
        timestamp: 0,
        status: 0,
        symbol: null
      },
      more: {
        show: false,
        loading: false
      },
      items: [],
      count: 0,
      delay: false
    }
  },
  components: {
    TimeAgo,
    Widget
  },
  metaInfo() {
    return {
      title: 'Wallet - Transactions'
    }
  },
  mounted() {
    this.getTransactions(0);
  },
  methods: {
    getMore() {
      this.getTransactions(this.$data.items[this.$data.items.length - 1].id);
    },
    getTransactions(last) {

      if (last) {
        this.$data.more.loading = true;
      } else {
        this.$data.delay = true;
      }

      axios.post(api.explorer.getTransactions, {last: last, main: true, limit: 10}).then((response) => {

        if (!last) {
          this.$data.items = [];
        }

        if (response.data.source !== undefined) {
          this.$data.count = response.data.count;
          for (let i = 0; i < response.data.source.length; i++) {

            const BN = this.$web3.utils.BN;

            this.$data.item.from = response.data.source[i].from;
            this.$data.item.to = response.data.source[i].to;
            this.$data.item.id = response.data.source[i].id;
            this.$data.item.hash = response.data.source[i].tx;
            this.$data.item.value = response.data.source[i].value ? response.data.source[i].value : (response.data.source[i].token_value ? response.data.source[i].token_value : 0);
            this.$data.item.check_nonce = response.data.source[i].check_nonce;
            this.$data.item.fee = this.$web3.utils.fromWei(new BN(response.data.source[i].gas_price * response.data.source[i].gas_limit).toString(), 'ether')
            this.$data.item.timestamp = response.data.source[i].timestamp;
            this.$data.item.contract = response.data.source[i].contract;
            this.$data.item.deploy = response.data.source[i].deploy;
            this.$data.item.status = response.data.source[i].status;

            if (response.data.source[i].token !== undefined) {
              this.$data.item.symbol = response.data.source[i].token[0].symbol;
              this.$data.item.value = response.data.source[i].token[0].value ? response.data.source[i].token[0].value : 0;
            }

            this.$data.items.push(Object.assign({}, this.$data.item));
          }
          this.$data.more.show = this.$data.count > this.$data.items.length;
        } else {
          this.$data.more.show = false;
        }

        if (last) {
          this.$data.more.loading = false;
        }

        this._.delay(() => {
          this.$data.delay = false;
        }, 1000);
      }).catch(() => {
        this.$data.delay = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
